import { defineComponent as D, mergeModels as I, useModel as N, computed as c, inject as P, getCurrentInstance as $, ref as K, toValue as S, provide as M, createElementBlock as k, openBlock as _, mergeProps as E, unref as o, createCommentVNode as O, createVNode as j, withCtx as q, renderSlot as w } from "vue";
import r from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/DataList/data-list.js";
import { useOUIAProps as U } from "../../helpers/ouia.js";
import { DataListKey as z } from "./DataList.vue2.js";
import F from "../../helpers/AutoWrap.vue2.js";
import G from "./DataListItemRow.vue2.js";
import H from "./DataListContent.vue2.js";
const J = ["tabindex", "aria-selected"], Q = ["name", "value", "type", "checked"], R = Symbol("DataListItemKey"), le = /* @__PURE__ */ D({
  name: "PfDataListItem",
  __name: "DataListItem",
  props: /* @__PURE__ */ I({
    selected: { type: Boolean, default: void 0 },
    selectionInputName: {},
    selectionInputValue: {},
    expandable: { type: Boolean, default: void 0 },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ I(["click", "update:selected"], ["update:expanded"]),
  setup(v, { emit: h }) {
    const a = v, V = U({ id: a.ouiaId, safe: a.ouiaSafe }), x = N(v, "expanded"), y = h, g = Symbol(), m = c(() => a.selected !== void 0), e = P(z), p = $(), u = (() => {
      const i = K(!1), d = () => a.selectionInputValue ?? (p == null ? void 0 : p.vnode.key) ?? g;
      return c({
        get() {
          if (m.value)
            return !!a.selected;
          if (e != null && e.selectable.value) {
            const t = d(), n = S(e.itemSelection);
            return Array.isArray(n) ? n.includes(t) : n === t;
          }
          return i.value;
        },
        set(t) {
          if (!m.value)
            if (e != null && e.selectable.value) {
              const n = d();
              let l = S(e.itemSelection);
              if (e.multipleSelection.value) {
                Array.isArray(l) || (l ? l = [l] : l = []);
                const f = l.indexOf(n);
                t && f === -1 ? l.push(n) : !t && f !== -1 && l.splice(f, 1);
              } else
                l = t ? n : void 0;
              e.emit("update:selected", l);
            } else
              i.value = t;
          y("update:selected", t);
        }
      });
    })(), s = c(() => m.value || !!(e != null && e.selectable.value)), C = c(() => a.expandable !== void 0 || !!(e != null && e.expandable.value)), B = c(() => a.selectionInputName || (e == null ? void 0 : e.inputName.value)), L = c(() => a.selectionInputValue || (e == null ? void 0 : e.inputValue.value));
    M(R, {
      expanded: x,
      expandable: C
    });
    function b() {
      s.value && (u.value = !u.value);
    }
    function A(i) {
      b(), y("click", i);
    }
    return (i, d) => {
      var t;
      return _(), k("li", E(o(V), {
        class: [
          o(r).dataListItem,
          {
            [o(r).modifiers.expanded]: x.value,
            [o(r).modifiers.clickable]: s.value,
            [o(r).modifiers.selected]: o(u)
          }
        ],
        tabindex: s.value ? 0 : void 0,
        "aria-selected": s.value && o(u) ? "true" : void 0,
        onClick: d[0] || (d[0] = (n) => A(n))
      }), [
        s.value ? (_(), k("input", {
          key: 0,
          name: B.value,
          value: L.value,
          class: "pf-v6-screen-reader",
          type: (t = o(e)) != null && t.multipleSelection ? "checkbox" : "radio",
          tabindex: "-1",
          checked: o(u),
          onChange: b
        }, null, 40, Q)) : O("", !0),
        j(F, {
          component: G,
          exclude: H
        }, {
          default: q(() => [
            w(i.$slots, "default")
          ]),
          _: 3
        })
      ], 16, J);
    };
  }
});
export {
  R as DataListItemKey,
  le as default
};
